import { GetAuditBatchResponse } from '@scale/shared/types/corp/attemptAudit';
import { IAttemptAuditJson } from '@scale/shared/types/speedAudit';
import { useMutation } from 'react-query';
import {
  AuditDto,
  useAuditActions,
} from 'react-scale/components/ExpertManagement/stores/audit.store';
import apiFetch, { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';

export const useFetchAuditFromBatchId = () => {
  const setLoadedAudit = useAuditActions().setLoadedAudit;
  return useMutation<AuditDto | undefined, Error, { batchId: string; projectId: string }>(
    'useFetchAuditFromBatchId',
    async ({ batchId, projectId }) => {
      try {
        const { attemptIds, auditBatch, projectInstrItems } = await apiFetch<GetAuditBatchResponse>(
          null,
          `corp-api/attemptAudit/auditBatches/${batchId}`,
          {
            method: 'GET',
          },
        );
        const { attemptAudits } = auditBatch;
        const auditDto = {
          auditBatch,
          attemptAudits: attemptAudits as IAttemptAuditJson[],
          projectInstrItems: projectInstrItems ?? [],
          attemptIds,
          projectId,
        };
        setLoadedAudit(auditDto);
        return auditDto;
      } catch (e) {
        defaultApiFetchErrorHandler(e, { handleHttp: true });
      }
    },
  );
};
